<template>
  <section class="slice slice-lg">
    <div class="container">

      <!--   grid3   -->
      <m-g3>
        <slot name="p1"/>
      </m-g3>
      <!--   grid3   -->

      <!--   grid1   -->
      <m-g1>

        <template #pl-1>
          <slot name="plt-1"></slot>
        </template>

        <template #pr-1>
          <slot name="plr-1"></slot>
        </template>

      </m-g1>
      <!--   grid1   -->

      <!--   grid1   -->
      <m-g1>

        <template #pr-1>
          <slot name="pbr-1"></slot>
        </template>

        <template #pl-1>
          <slot name="pbl-1"></slot>
        </template>

      </m-g1>
      <!--   grid1   -->


    </div>
  </section>
</template>

<script>
export default {
  name: "S2",
};
</script>

<style scoped>

.icon i,
.icon svg {
  font-size: 2.75rem;
}

.fluid-paragraph {
  width: 680px;
  margin: auto;
  padding: 0 1.5rem;
  position: relative;
}

@media (max-width: 767.98px) {
  .fluid-paragraph {
    width: 100%;
  }
}

.card.hover-shadow-lg {
  position: relative;
  margin-bottom: 30px;
  box-shadow: 0 0.75rem 1.5rem rgb(18 38 63 / 3%);
}

.card.hover-scale-110:hover {
  z-index: 2;
  border-radius: 0.375rem !important;
}

.hover-shadow-lg:hover {
  box-shadow: 0 1rem 3rem rgb(31 45 61 / 13%) !important;
}
</style>